import { useState } from "react"

import { useAuth } from "../hooks/useAuth"
import type { Theme } from "../hooks/useTheme"
import { useTheme } from "../hooks/useTheme"

type Panel = "debug" | "theme" | null

const THEMES: Theme[] = ["light", "dark", "system"]

const btnCls = (active: boolean) =>
  `px-3 py-2 text-xs capitalize outline-none ${active ? "text-white" : "text-zinc-500"}`

export function DebugBar() {
  const { user, loading, error, claims } = useAuth()
  const data = {
    loading,
    user: user
      ? {
          uid: user.uid,
          email: user.email,
          provider: user.providerData[0]?.providerId,
        }
      : null,
    claims,
    error: error ? String(error) : null,
  }
  const [open, setOpen] = useState(false)
  const [panel, setPanel] = useState<Panel>(null)
  const [theme, setTheme] = useTheme()

  if (!import.meta.env.VITE_SHOW_DEBUG_BAR) return null

  const toggle = (p: Panel) => setPanel((prev) => (prev === p ? null : p))
  const close = () => {
    setOpen(false)
    setPanel(null)
  }

  return (
    <div className="fixed bottom-4 left-4 z-50 flex flex-col items-start gap-1.5">
      {panel === "debug" && (
        <pre className="m-0 max-h-[70vh] w-72 overflow-auto rounded-lg border border-zinc-800 bg-zinc-900 p-3 text-xs text-emerald-400">
          {JSON.stringify(data, null, 2)}
        </pre>
      )}

      {panel === "theme" && (
        <div className="flex gap-1 overflow-hidden rounded-lg border border-zinc-800 p-1">
          {THEMES.map((t) => (
            <button
              key={t}
              onClick={() => setTheme(t)}
              className={btnCls(theme === t)}
            >
              {t}
            </button>
          ))}
        </div>
      )}

      <div className="flex gap-1 overflow-hidden rounded-lg border border-zinc-800 p-1">
        <button
          onClick={open ? close : () => setOpen(true)}
          className={btnCls(false)}
        >
          🐛
        </button>
        {open && (
          <>
            <button
              onClick={() => toggle("debug")}
              className={btnCls(panel === "debug")}
            >
              Debug
            </button>
            <button
              onClick={() => toggle("theme")}
              className={btnCls(panel === "theme")}
            >
              Theme
            </button>
          </>
        )}
      </div>
    </div>
  )
}
